<template><div><h1>微信 Vue 单页面应用设置标题</h1>
<p>在微信<code>iOS</code> <code>webview</code>更新到<code>WKWebView</code>之前我们可以通过加载一个 <code>iframe</code> 来实现单页面应用<code>title</code>更改。但是17年初更新到 <code>WKWebView</code> 后该方法也失效。</p>
<p>目前该问题已经解决，在微信 iOS 客户端 <code>6.3.5</code> 之后的版本都可以通过 <code>document.title</code> 设置标题了。</p>
</div></template><script>
export default {
  head: {"title":"微信 Vue 单页面应用设置标题 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// wechat-document-title-191.vue?26adb42f